

import React, { useRef } from "react";
import Table from "react-bootstrap/Table";
import { Bar } from "react-chartjs-2";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

// Import chart.js modules
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);



const utahData = "/img/headerlogo.png";
const kpi = "/img/KPI-DASH 2.png";
const bodex = "/img/bodexLogo.png";
const pdf = "/img/pdf1.png";
const AeroTable15 = ({ data }) => {
  const pdfRef = useRef(); // Reference for PDF export

  // Extract years for chart labels
  const years = ["2018", "2019", "2020", "2021", "2022", "2023", "2024"];
  const chartLabels = years;

  // Prepare data for the bar chart
  const chartData = {
    labels: chartLabels,
    datasets: data.map((item, index) => ({
      label: item["age_group_label"],
      data: years.map((year) => parseFloat(item[`male_${year}`]) || 0),
      backgroundColor: `hsl(${(index * 45) % 360}, 70%, 50%)`,
    })),
  };

  const downloadPDF = () => {
    const input = pdfRef.current;
    input.style.width = "1100px"; // Adjust width for better PDF rendering

    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Add Header
      pdf.addImage(utahData, "PNG", 60, 10, 32, 16);
      pdf.setFontSize(26);
      pdf.text("UTahData.org", 95, 22);
      pdf.line(10, 35, 200, 35);

      // Add Content
      pdf.addImage(imgData, "PNG", 5, 38, imgWidth, imgHeight);

      // Add Footer
      pdf.line(10, 260, 200, 260);
      pdf.addImage(utahData, "PNG", 22, 265, 30, 15);
      pdf.setFontSize(10);
      pdf.addImage(kpi, "PNG", 125, 265, 20, 20);
      pdf.text("Built by", 55, 275);
      pdf.addImage(bodex, "PNG", 68, 269, 44, 10);
      pdf.text("using", 112, 275);
      pdf.text(" 20250916.v3.198", 148, 275);
      const currentDate = new Date().toLocaleDateString();
      pdf.text(`Downloaded on: ${currentDate}`, 150, 295);
      const currentURL = window.location.href;
      pdf.text(`Downloaded from: ${currentURL}`, 10, 295);

      pdf.save("male-female-employment-trend.pdf");
      input.style.width = ""; // Reset width
    });
  };

  return (
    <div className="container">
      <div ref={pdfRef} className="content-to-export">
        <h3 className="mt-3">Employment Trend by Age Group (2018-2024)</h3>

        {/* Table Section */}
        <Table striped bordered hover responsive className="mb-4 bg-white">
          <thead>
            <tr>
              <th>Age Group</th>
              {years.map((year) => (
                <th key={`male_${year}`}>Male {year}</th>
              ))}
              {years.map((year) => (
                <th key={`female_${year}`}>Female {year}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td>{item["age_group_label"]}</td>
                {years.map((year) => (
                  <td key={`male_${year}`}>{item[`male_${year}`]}</td>
                ))}
                {years.map((year) => (
                  <td key={`female_${year}`}>{item[`female_${year}`]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>


        <div
          style={{
            width: "90%",
            maxWidth: "800px",
            margin: "auto",
            overflowX: "auto",
          }}
        >
          {" "}
          <div
            style={{
              width: "100%", // Takes 100% width of the parent div, but will scroll if needed
              minWidth: "600px", // Ensures a minimum width, enabling scroll when the chart exceeds screen size
              height: "400px",
              background: "#fff",
            }}
          >
            <Bar
              data={chartData}
              options={{
                responsive: true,
                plugins: {
                  legend: {
                    position: "top",
                  },
                  title: {
                    display: true,
                    text: "Male Employment Trend by Age Group",
                  },
                },
              }}
            />
          </div>
        </div>
      </div>

      <div className="text-center mt-4">
        <div className="flex justify-center mt-4">
          <button
            onClick={downloadPDF}
            className="download-btn bg-red-800 hover:bg-red-950 p-2 text-white rounded-lg flex items-center justify-between"
          >
            <span>Download as PDF</span>
            <span>
              <img className="w-[2rem]" src={pdf} alt="PDF Icon" />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AeroTable15;
